import { Box, MenuItem, Pagination, Select, SelectChangeEvent, Stack } from '@mui/material';
import { memo, useMemo } from 'react';
import CustomTablePaginationSkeleton from './CustomTablePaginationSkeleton';

interface ICustomTablePaginationProps {
  count: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  duration: number;
}

function CustomTablePagination({
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  isLoading,
  duration,
}: ICustomTablePaginationProps): JSX.Element {
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    onPageChange(event, value - 1);
  };

  const totalPages = useMemo(() => Math.ceil(count / rowsPerPage), [count, rowsPerPage]);
  const handleRowsPerChange = (event: SelectChangeEvent) => {
    onRowsPerPageChange(event as React.ChangeEvent<HTMLInputElement>);
  };
  return (
    <>
      {isLoading && duration >= 0.5 && <CustomTablePaginationSkeleton />}
      {!isLoading && (
        <Box
          sx={{
            display: 'flex',
            gridColumn: 3,
            gridRow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 50,
            height: 'auto',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
            <Pagination count={totalPages} page={page + 1} onChange={handleChange} showFirstButton showLastButton />
          </Box>
          <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" sx={{ mr: 2 }}>
            <Box>페이지당</Box>
            <Select
              value={`${rowsPerPage}`}
              onChange={handleRowsPerChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Rows per props' }}
              sx={theme => ({
                borderRadius: '4px',
                color: theme.palette.text.primary,
                '& .MuiSvgIcon-root': {
                  right: '8px',
                },
                '& .MuiPopover-paper': {
                  maxHeight: '200px',
                },
                '& .MuiInputBase-input': {
                  padding: '6.5px 8px',
                },
              })}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                sx: { '& .MuiMenu-paper': { maxWidth: '320px', maxHeight: '200px' } },
              }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={200}>200</MenuItem>
              <MenuItem value={300}>300</MenuItem>
              <MenuItem value={400}>400</MenuItem>
              <MenuItem value={500}>500</MenuItem>
            </Select>
          </Stack>
        </Box>
      )}
    </>
  );
}

export default memo(CustomTablePagination);
